import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import { createNewKategorija, createNewLekcija, createNewPodoblast, updateNewLekcija } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import MDEditor from '@uiw/react-md-editor';

type Inputs = {
    naziv: string;
    opis: string;
    redosled: number | undefined;
};

function AddLekcijaModal({ modalIsOpen, closeModal, podoblast, lekcija, reloadLekcije }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const [isSurvey, setIsSurvey] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        control,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (!!lekcija?.id) {
            setValue('naziv', lekcija.naziv);
            setValue('opis', lekcija.opis);
            setValue('redosled', lekcija.redosled);
            setIsSurvey(lekcija.isSurvey);
            setVisible(lekcija.visible);
        } else {
            reset();
        }
    }, [lekcija]);
    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!lekcija?.id) updateLekcija();
        else {
            createLekcija();
        }
    };
    const createLekcija = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.podoblastId = podoblast?.id;
        data.visible = visible;
        data.isSurvey = isSurvey;
        const resp = await createNewLekcija(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste kreirali novu lekciju!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updateLekcija = async () => {
        setLoading(true);
        let data: any = getValues();
        data.id = lekcija?.id;
        data.redosled = getValues('redosled')?.toString();
        data.podoblastId = podoblast?.id;
        data.visible = visible;
        data.isSurvey = isSurvey;
        const resp = await updateNewLekcija(data);
        if (resp.status == 201) {
            reloadLekcije();
            notif('Uspešno ste izmenili lekciju!');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };

    const changeIsSurvey = () => {
        setIsSurvey((prev) => !prev);
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                reset();
                setIsSurvey(false);
                setVisible(true);
            }}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="   max-h-[600px] w-full  ">
                <form
                    className="flex flex-col items-center w-full bg-white px-[40px] py-[30px] rounded-[10px]"
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                >
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv lekcije</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Naziv kategorije"
                                {...register('naziv', {
                                    validate: {
                                        obavezno: (value) => value.length > 0,
                                    },
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.naziv?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                        </p>
                    </div>
                    <div className="mt-4 w-full">
                        <div className="flex flex-row items-end justify-between gap-5">
                            <p
                                className={`text-black font-semibold text-lg text-left ${errors.opis?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}
                            >
                                Opis lekcije
                            </p>

                            <p className="text-redError font-medium text-lg  ">{errors.opis?.type === 'required' ? '* This field is required' : ''}</p>
                        </div>
                        <Controller
                            control={control}
                            name="opis"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <MDEditor
                                    value={field.value}
                                    onChange={(value: any) => setValue('opis', value, { shouldValidate: true })}
                                    className="preview-list"
                                    preview="edit"
                                />
                            )}
                        />
                    </div>
                    <div className="flex flex-col w-full mt-5">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled lekcije</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Redosled lekcije"
                                type="number"
                                {...register('redosled', {
                                    min: 0,
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px]  leading-5 h-5 ">
                            <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                        </p>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeVisibilty()}
                            >
                                {visible && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Lekcija vidljiva</label>
                        </div>
                    </div>
                    <div className="w-full">
                        <div className={`flex flex-row items-center cursor-pointer my-2`}>
                            <div
                                className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                onClick={() => changeIsSurvey()}
                            >
                                {isSurvey && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                            </div>
                            <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Da li je lekcija test (survey)</label>
                        </div>
                    </div>
                    <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-5 justify-end">
                        <button
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal();
                            }}
                        >
                            <p>Otkaži</p>
                        </button>
                        <button
                            type="submit"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <ConfirmIcon />
                                    <p>Potvrdi</p>
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
}

export default AddLekcijaModal;
